const ID = /^[A-Za-z0-9_-]{11}$/;
const HOSTS = ["youtube.com", "www.youtube.com", "m.youtube.com", "music.youtube.com", "youtube-nocookie.com", "www.youtube-nocookie.com"];

/**
 * The 11-character video id from a YouTube URL, or null for anything else. The
 * embed is only ever built from this id, never from the URL itself, so a config
 * value can at worst name a different YouTube video — it cannot point an iframe
 * at another site. Mirrors HrnForms.YouTube on the server.
 */
export function youtubeId(url: string | undefined | null): string | null {
  if (!url) return null;

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  if (parsed.protocol !== "https:") return null;

  const host = parsed.hostname.toLowerCase();
  const parts = parsed.pathname.split("/").filter(Boolean);
  let id: string | null = null;

  if (host === "youtu.be") {
    id = parts[0] ?? null;
  } else if (HOSTS.includes(host)) {
    if (parts[0] === "watch") id = parsed.searchParams.get("v");
    else if (["embed", "shorts", "live", "v"].includes(parts[0])) id = parts[1] ?? null;
  }

  return id && ID.test(id) ? id : null;
}
